module.exports = __webpack_public_path__ + "static/media/ednoVreme.baa5fc2b.png";